export const isLocalMode: boolean = false; // Change to false for production

export const aiRequestUrl: string = isLocalMode
  ? "http://127.0.0.1:5001/profileanalyserfunctions-dd2ca/us-central1/makeAiRequest"
  : "https://us-central1-profileanalyserfunctions-dd2ca.cloudfunctions.net/makeAiRequest";
